<template>
    <div>
        <div class="detailsBox">
            <div class="detailsTitle">
                <h4>证据详情</h4>
                <p style="border: 1px solid #3b63f6"></p>
            </div>
            <div class="contentBox">
                <div class="business">
                    <div class="pact">
                        <p>业务合同: </p>
                        <span>已完成</span>
                    </div>
                    <div class="serialNumber">
                        <p>合同编号: </p>
                        <span>20220561561651651</span>
                    </div>
                    <div class="quantity">
                        <p>证据数量: </p>
                        <span>10个</span>
                    </div>
                </div>
<!--                签署方-->
                <div class="contractPartyBox" v-for="item in 3">
                    <div class="contractParty">
                        <p>签约方:</p>
                        <span>河北速保全网络科技有限公司</span>
                    </div>
                    <div class="cellPhone">
                        <p>手机号:</p>
                        <span>15546324585</span>
                    </div>
                    <div class="signingTime">
                        <p>签署时间:</p>
                        <span>2022.10.19  12:05:10</span>
                    </div>
                </div>
<!--                发起时间-->
                <div class="initiationTimeBox">
                    <div class="initiationTime">
                        <p>发起时间:</p>
                        <span>2022.09.22  18:06:12</span>
                    </div>
                    <div class="deadlineBox">
                        <p>截止时间:</p>
                        <span>2022.10.15  08:30:22</span>
                    </div>
                </div>
<!--                一键下载-->
                <div class="download">
                    <el-button type="primary">一键下载</el-button>
                    <el-button type="primary">提交案件</el-button>
                </div>
            </div>
<!--            证据列表-->
            <div class="evidenceList">
                <evidenceList></evidenceList>
            </div>
        </div>
    </div>
</template>

<script>
    import evidenceList from "./evidenceList";

    export default {
        name: "particulars",
        components:{
            evidenceList
        }
    }
</script>

<style scoped>
    .detailsBox{
        padding: 30px;
        background-color: #fff;
    }
    .detailsTitle>h4{
        color: #3b63f6;
        width: 80px;
        text-align: center;
        margin-bottom: 10px;
    }
    .detailsTitle>p{
        width: 80px;
    }
    /*详情内容*/
    .contentBox{
        padding: 20px 10px;
    }
    .pact{
    }
    .business{
        display: flex;
        padding: 10px 0px;
    }
    .business>div{
        width: 30%;
        display: flex;
    }
    .business p{
        color: #9f9fa2;
        margin-right: 5px;
    }
    .business span{
        color: #535354;
    }
    /*签署方*/
    .contractPartyBox{
        display: flex;
        padding: 10px 0px;
    }
    .contractPartyBox>div{
        display: flex;
        width: 30%;
    }
    .contractPartyBox p{
        color: #9f9fa2;
        margin-right: 5px;
    }
    .contractPartyBox span{
        color: #535354;
    }
    /*发起时间*/
    .initiationTimeBox{
        display: flex;
        padding: 10px 0px;
    }
    .initiationTimeBox>div{
        display: flex;
        width: 30%;
    }
    .initiationTimeBox p{
        color: #9f9fa2;
        margin-right: 5px;
    }
    .initiationTimeBox span{
        color: #535354;
    }
/*    一键下载*/
    .download{
        padding: 10px 0px;
    }

</style>
